/* AOV checkout: quote and create share an immutable composition. No tracking here.
 * Final Worker contract: decimal BOB on the wire, integer cents internally.
 */
(function (root) {
  'use strict';
  var VERSION = 'bio-aov-2026-10-02';
  var PENDING_KEY = 'bo_aov_pending_v1';
  var attempt = null;
  var inFlight = Object.create(null);
  function error(code, detail) {
    var e = new Error(code);
    e.code = code;
    if (detail) e.detail = detail;
    return e;
  }
  function amount(n) { return Number.isSafeInteger(n) && n >= 0; }
  function pending() {
    if (attempt) return attempt.record;
    try {
      var record = JSON.parse(root.sessionStorage.getItem(PENDING_KEY) || 'null');
      return record && typeof record.idempotencyKey === 'string' ? record : null;
    } catch (_) { return null; }
  }
  function identity(p) {
    return JSON.stringify({ items: root.BoAovCatalog.normalize(p.items), customer: p.customer,
      shipping: p.shipping, offerId: p.offerId, pricingVersion: p.pricingVersion,
      discountPct: p.discountPct || 0, discountCode: p.discountCode || '', expectedTotalCents: p.expectedTotalCents });
  }
  function remember(p, endpoint, q, requestIdentity) {
    var saved = pending();
    if (saved && (!attempt || saved.idempotencyKey !== p.idempotencyKey ||
        attempt.endpoint !== endpoint || identity(attempt.payload) !== identity(p))) {
      throw error('aov_order_pending', saved);
    }
    if (attempt) return attempt.payload;
    // Persist only the opaque request key, never customer details. A reload after
    // an uncertain create blocks a new order until the previous one is checked.
    var record = { idempotencyKey: p.idempotencyKey, startedAt: Date.now() };
    try { root.sessionStorage.setItem(PENDING_KEY, JSON.stringify(record)); }
    catch (_) { throw error('aov_session_unavailable'); }
    attempt = { record: record, endpoint: endpoint, payload: p, quote: q, requestIdentity: requestIdentity };
    return p;
  }
  function clearPending() {
    attempt = null;
    try { root.sessionStorage.removeItem(PENDING_KEY); } catch (_) {}
  }
  function sameItems(a, b) {
    var x = root.BoAovCatalog.normalize(a), y = root.BoAovCatalog.normalize(b);
    return !!x && !!y && JSON.stringify(x) === JSON.stringify(y);
  }
  var RULE_IDS = {
    'tiras-tapones': 'tiras1-tapones1', 'dos-tiras-tapones': 'tiras2-tapones1',
    'lentes-tiras': 'lente1-tiras1', 'lentes-tapones': 'lente1-tapones1',
    'dilatador-tapones': 'dilatador1-tapones1',
    'dilatador-repuesto-tapones': 'dilatador1-repuesto1-tapones1',
    'lentes-tiras-tapones': 'lente1-tiras1-tapones1'
  };
  var LIST_CENTS = { lentes: 40000, tiras: 18000, dilatador: 30000, repuesto: 16000, tapones: 25000 };
  function cents(n) {
    if (typeof n !== 'number' || !Number.isFinite(n) || n < 0) return null;
    var value = Math.round(n * 100);
    return amount(value) && Math.abs(n * 100 - value) < 0.000001 ? value : null;
  }
  function family(id) {
    var name = root.BoAovCatalog.family(id);
    return name === 'stickers' ? 'repuesto' : name;
  }
  function validComposition(composition, items) {
    if (!composition || typeof composition !== 'object') return false;
    var counts = { lentes: 0, tiras: 0, dilatador: 0, repuesto: 0, tapones: 0 };
    items.forEach(function (item) { counts[family(item.variantId)] += item.quantity; });
    return Object.keys(composition).length === 5 && Object.keys(counts).every(function (name) {
      return composition[name] === counts[name];
    });
  }
  function decodeAmounts(q, expected, shippingMode) {
    if (!q || q.ok !== true || q.pricingVersion !== VERSION || q.offerId !== 'aov-kit-v1' ||
        q.currency !== 'BOB' || !q.rule || q.rule.id !== RULE_IDS[expected.key] ||
        !validComposition(q.composition, expected.items)) throw error('aov_quote_invalid');
    var shipping = q.shipping;
    if (!shipping || (shipping.mode !== 'cod' && shipping.mode !== 'encomienda') ||
        (shippingMode && shipping.mode !== shippingMode) || typeof shipping.label !== 'string' ||
        cents(shipping.amount) !== (shipping.mode === 'encomienda' ? 1000 : 0)) {
      throw error('aov_price_unavailable');
    }
    var fields = { subtotal: 'subtotalCents', discount: 'discountCents', productsTotal: 'goodsCents',
      referenceTotal: 'comparisonCents', savingVsReference: 'savingsCents' };
    var normalized = {};
    if (!Object.keys(fields).every(function (field) {
      normalized[fields[field]] = cents(q[field]);
      return normalized[fields[field]] !== null && normalized[fields[field]] === expected[fields[field]];
    })) throw error('aov_price_unavailable');
    normalized.shippingCents = cents(shipping.amount);
    normalized.totalCents = cents(q.total);
    if (normalized.totalCents === null || normalized.totalCents !== normalized.goodsCents + normalized.shippingCents) {
      throw error('aov_price_unavailable');
    }
    return Object.assign(normalized, { offerId: q.offerId, pricingVersion: q.pricingVersion,
      currency: q.currency, ruleId: q.rule.id,
      items: Object.freeze(expected.items.map(function (item) { return Object.freeze({ variantId: item.variantId, quantity: item.quantity }); })),
      shipping: Object.freeze({ mode: shipping.mode, amount: shipping.amount, label: shipping.label }) });
  }
  function decodeQuote(q, expected, shippingMode) {
    if (!expected || !q || q.action !== 'quote' || !sameItems(q.lines, expected.items)) throw error('aov_quote_invalid');
    var normalized = decodeAmounts(q, expected, shippingMode);
    if (!q.lines.every(function (line) {
      var name = family(line.variantId);
      return name === line.family && cents(line.unitPrice) === LIST_CENTS[name] &&
        cents(line.lineSubtotal) === LIST_CENTS[name] * line.quantity;
    })) throw error('aov_price_unavailable');
    var global = q.stock && q.stock.global;
    if (q.purchasable !== true || !global || global.status !== 'available' ||
        !Array.isArray(global.lines) || global.lines.length !== expected.items.length ||
        !expected.items.every(function (item) {
          return global.lines.filter(function (line) { return line.variantId === item.variantId && line.status === 'available'; }).length === 1;
        })) throw error('aov_stock_unconfirmed');
    // Local stock is deliberately not verified by this Worker. The popup makes
    // that limitation visible; global availability alone gates this checkout.
    return Object.freeze(normalized);
  }
  async function quote(options) {
    var p = options.payload, catalog = root.BoAovCatalog;
    var expected = catalog && catalog.match(p && p.items);
    if (!expected || p.offerId !== expected.offerId || p.pricingVersion !== VERSION ||
        (p.discountPct || 0) !== 0 || String(p.discountCode || '').trim()) {
      throw error('aov_selection_invalid');
    }
    var customer = p.customer || {};
    var city = p.shipping === 'encomienda' ? customer.province : customer.city;
    if (!city || city === '__otra__') throw error('aov_city_required');
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 12000);
    var raw, response;
    try {
      response = await (options.fetchImpl || root.fetch)(options.endpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: controller.signal,
        body: JSON.stringify({ action: 'quote', offerId: expected.offerId,
          pricingVersion: VERSION, items: expected.items, shipping: p.shipping,
          customer: { city: customer.city || city } })
      });
      raw = await response.json();
    } catch (e) {
      throw error('aov_quote_unavailable');
    } finally { clearTimeout(timer); }
    if (!response.ok) throw error('aov_quote_unavailable');
    return decodeQuote(raw, expected, p.shipping);
  }
  async function runSubmit(options) {
    // Capture now: changing controls while a quote is pending cannot change create.
    var p = JSON.parse(JSON.stringify(options.payload || {}));
    if (!p.idempotencyKey || !options.endpoint) throw error('aov_selection_invalid');
    var expected = root.BoAovCatalog.match(p.items);
    if (!expected) throw error('aov_selection_invalid');
    var requestIdentity = identity(p);
    var saved = pending(), q;
    if (saved) {
      if (!attempt || saved.idempotencyKey !== p.idempotencyKey || attempt.endpoint !== options.endpoint ||
          attempt.requestIdentity !== requestIdentity || options.expectedTotalCents !== attempt.quote.totalCents) {
        throw error('aov_order_pending', saved);
      }
      q = attempt.quote;
      p = attempt.payload;
    } else {
      if (options.onState) options.onState({ name: 'quoting' });
      q = await quote(Object.assign({}, options, { payload: p }));
    }
    if (!amount(options.expectedTotalCents) || q.totalCents !== options.expectedTotalCents) {
      throw error('aov_quote_changed', q);
    }
    p.saving = q.discountCents / 100;
    p.discountPct = 0;
    p.discountCode = '';
    p.expectedTotal = q.totalCents / 100;
    p.expectedTotalCents = q.totalCents;
    p.expectedGoodsCents = q.goodsCents;
    delete p.postOffer;
    delete p.postOffers;
    var create = options.createImpl || (root.BoCodRequest && root.BoCodRequest.submit);
    if (typeof create !== 'function') throw error('aov_checkout_unavailable');
    p = remember(p, options.endpoint, q, requestIdentity);
    var result, failureBody = null;
    // BoCodRequest exposes only the error code/status. Inspect a clone to retain
    // quote_changed's embedded quote without changing its retry/honeypot logic.
    var fetchCreate = async function (url, init) {
      var response = await (options.createFetchImpl || root.fetch)(url, init);
      failureBody = null;
      if (!response.ok) {
        try { failureBody = await response.clone().json(); } catch (_) {}
      }
      return response;
    };
    try {
      result = await create({ endpoint: options.endpoint, payload: p,
        timeoutMs: options.timeoutMs, onState: options.onState, fetchImpl: fetchCreate });
    } catch (e) {
      if (Number(e.status) === 409 && e.code === 'quote_changed') {
        // The Worker guarantees no order was created. Release the attempt before
        // decoding, so even a broken new quote cannot masquerade as an order.
        clearPending();
        var changed = e.quote || (e.detail && e.detail.quote) || (failureBody && failureBody.quote);
        throw error('aov_quote_changed', decodeQuote(changed, expected, p.shipping));
      }
      var definitive = ['pricing_version_mismatch', 'kit_out_of_stock', 'kit_stock_unknown',
        'kit_price_basis_changed', 'kit_not_combinable'];
      if ((e.code !== 'invalid_response' && [400, 401, 403, 404, 405, 422, 429].indexOf(Number(e.status)) >= 0) ||
          (Number(e.status) === 409 && definitive.indexOf(e.code) >= 0)) clearPending();
      // Network/5xx/in-progress and malformed success retain the exact accepted
      // quote/key/payload. A replay must not recheck stock or build a new order.
      throw e;
    }
    try {
      if (!result || typeof result.orderId !== 'string' || !/^gid:\/\/shopify\/Order\/[1-9]\d*$/.test(result.orderId) ||
          !sameItems(result.items, q.items)) throw error('aov_order_unverified');
      var returned = decodeAmounts(result, expected, q.shipping.mode);
      if (returned.totalCents !== q.totalCents || returned.shippingCents !== q.shippingCents) throw error('aov_order_unverified');
    } catch (_) {
      // An uncertain result must never get a new idempotency key or Purchase.
      throw error('aov_order_unverified', { orderId: result && result.orderId || '', idempotencyKey: p.idempotencyKey });
    }
    clearPending();
    return result;
  }
  function submit(options) {
    var key = options && options.payload && options.payload.idempotencyKey;
    if (key && inFlight[key]) {
      if (inFlight[key].requestIdentity !== identity(options.payload) || inFlight[key].endpoint !== options.endpoint || inFlight[key].expectedTotalCents !== options.expectedTotalCents) return Promise.reject(error('aov_order_pending'));
      return inFlight[key];
    }
    var saved = pending();
    if (saved && (!attempt || saved.idempotencyKey !== key)) return Promise.reject(error('aov_order_pending', saved));
    var work = runSubmit(options).finally(function () { delete inFlight[key]; });
    work.requestIdentity = identity(options.payload);
    work.endpoint = options.endpoint;
    work.expectedTotalCents = options.expectedTotalCents;
    if (key) inFlight[key] = work;
    return work;
  }
  root.BoAovCheckout = Object.freeze({ quote: quote, submit: submit, decodeQuote: decodeQuote, pending: pending });
})(typeof globalThis !== 'undefined' ? globalThis : this);
